<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12">
                <b-card no-body>
                    <b-tabs v-model="upload_tab_idx" card>
                        <b-tab :title="$t('첨부파일 관리')" no-body>
                            <b-row>
                                <b-col cols="12">
                                    <b-table :items="get_attatchments" :fields="attachments_field"
                                        :empty-text="$t('업로드된 파일이 없습니다.')"
                                        show-empty
                                        :busy="is_loading_link_attachment || is_loading_delete_attachment"
                                        class="mb-0"
                                        >
                                        <template #empty="scope">
                                            <div class="text-center">
                                                <h6 class="gray-500 mb-0">{{ scope.emptyText }}</h6>
                                            </div>
                                        </template>

                                        <template #table-busy>
                                            <div class="text-center text-danger my-2">
                                                <strong class="mr-2">{{ $t('처리중입니다. 잠시만 기다려주세요...') }}</strong>
                                                <b-spinner class="align-middle" style="width: 1.3rem;height: 1.3rem;"></b-spinner>
                                            </div>
                                        </template>


                                        <template #cell(index)="data">
                                            <div class="text-center">
                                                {{ data.index + 1 }}.
                                            </div>
                                        </template>

                                        <template #cell(attachment_type)="data">
                                            <b-badge>{{ data.value.toLocaleUpperCase() }}</b-badge>
                                        </template>

                                        <template #cell(sub_list)="data">
                                            <template v-if="!data.value || !data.value.length">
                                                <div class="text-center gray-500 f-95">
                                                    {{ !data.value || !data.value.length ? $t('미첨부') : data.value.map(({ sub_code }) => sub_code).join(',') }}
                                                </div>
                                            </template>
                                            <template v-else>
                                                <!-- {{ data.value }} -->
                                                <div v-for="sub of data.value" :key="`attachment-${data.item.id}-sub-${sub.id}-${sub.sub_path}`" class="f-90">
                                                    <span class="">{{ get_question_name(sub) }}</span>
                                                    <span class="ml-1">- {{ get_sub_code_label(sub) }}</span>
                                                </div>
                                                <!-- <b-badge v-for="sub of data.value" :key="`attachment-${data.item.id}-sub-${sub.id}`" class="f-70">
                                                    {{ sub.sub_code }}
                                                </b-badge> -->
                                            </template>
                                        </template>

                                        <template #cell(user)="data">
                                            {{ data.value ? data.value.user_name : ' - '}}
                                        </template>

                                        <template #cell(created_at)="data">
                                            {{ formatDate(data.value) }}
                                        </template>

                                        <template #cell(action)="data">
                                            <b-btn-group>
                                                <b-btn size="sm" variant="warning" class="f-75"
                                                    :disabled="is_loading_global_disabled || (!data.item.sub_list || !data.item.sub_list.length)"
                                                    @click="unlinkAllAttachment(data.item)"
                                                    >
                                                    {{ $t('첨부 전체해제') }}
                                                </b-btn>
                                                <b-btn size="sm" variant="danger" class="f-75" :disabled="is_loading_global_disabled || (!!data.item.sub_list && data.item.sub_list.length > 0)"
                                                    @click="deleteAttachment(data)"
                                                    >
                                                    {{ $t('삭제') }}
                                                </b-btn>
                                            </b-btn-group>
                                        </template>
                                    </b-table>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab :title="$t('파일 업로드')" no-body>
                            <div class="p-4">
                                <b-row>
                                    <b-col cols="12">
                                        <b-card>
                                            <template #header>
                                                <div class="d-flex align-items-end justify-content-between">
                                                    <h5 class="mb-0">{{ $t('파일 업로드') }}</h5>

                                                    <div class="text-right">
                                                        <b-btn class="mr-2" variant="danger"
                                                            :disabled="is_loading_global_disabled || !uploading_list.length || saving_files"
                                                            size="sm"
                                                            @click="cancelAttachment"
                                                            >
                                                            {{ $t('취소') }}
                                                        </b-btn>
                                                        <b-btn variant="primary"
                                                            :disabled="is_loading_global_disabled || !uploading_list.length || saving_files"
                                                            size="sm"
                                                            @click="uploadAttachment"
                                                            >
                                                            {{ $t('파일 업로드') }}
                                                        </b-btn>
                                                    </div>
                                                </div>
                                            </template>
                                            <b-row>
                                                <b-col cols="12" lg="6">
                                                    <div class="mb-2">
                                                        <fa icon="paperclip" class="f-100 mr-2"></fa>
                                                        <span class="f-110">File</span>
                                                    </div>
                                                    <b-form-file
                                                        v-model="attachment_files"
                                                        :placeholder="attachment_uploader_placeholder"
                                                        :disabled="saving_files || is_loading_global_disabled"
                                                        class="text-left"
                                                        multiple
                                                        @input="addFiletoUploadList"
                                                        >
                                                    </b-form-file>
                                                </b-col>
                                                <b-col cols="12" lg="6">
                                                    <div class="mb-2">
                                                        <fa icon="link" class="f-100 mr-2"></fa>
                                                        <span class="f-110">URL</span>
                                                    </div>
                                                    <b-input-group>
                                                        <b-form-input v-model="attachment_url"
                                                            placeholder="https://"
                                                            :disabled="saving_files || is_loading_global_disabled"
                                                            @keypress.enter="addURLtoUploadList"
                                                            />
                                                        <b-input-group-append>
                                                            <b-button variant="light" class="border"
                                                                :disabled="!attachment_url"
                                                                @click="addURLtoUploadList"
                                                                >
                                                                <BIconPlus />
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-col>
                                            </b-row>
                                        </b-card>
                                    </b-col>
                                </b-row>
                            </div>
                            <b-row>
                                <b-col cols="12">
                                    <b-table :items="uploading_list"
                                        :fields="upload_fields"
                                        :empty-text="$t('업로드 할 파일을 선택해주세요')"
                                        show-empty
                                        :busy="is_loading_global_disabled || is_loading_add_attachment || saving_files"
                                        class="mb-0"
                                        >
                                        <template #empty="scope">
                                            <div class="text-center">
                                                <h6 class="gray-500 mb-0">{{ scope.emptyText }}</h6>
                                            </div>
                                        </template>

                                        <template #table-busy>
                                            <div class="text-center text-danger my-2">
                                                <strong class="mr-2">{{ $t('처리중입니다. 잠시만 기다려주세요...') }}</strong>
                                                <b-spinner class="align-middle" style="width: 1.3rem;height: 1.3rem;"></b-spinner>
                                            </div>
                                        </template>

                                        <template #cell(index)="data">
                                            {{ data.index + 1 }}
                                        </template>

                                        <template #cell(name)="data">
                                            {{ data.value }}
                                        </template>

                                        <template #cell(type)="data">
                                            <b-badge>{{ data.item.type.toLocaleUpperCase() }}</b-badge>
                                        </template>

                                        <template #cell(action)="data">
                                            <template v-if="data.item.type === 'file'">
                                                <b-btn variant="danger" size="sm"
                                                    @click="deleteFiletoUploadList(data.item)"
                                                    >
                                                    {{ $t("삭제하기") }}
                                                </b-btn>
                                            </template>
                                            <template v-else>
                                                <b-btn variant="danger" size="sm"
                                                    @click="deleteURLtoUploadList(data.item.url)"
                                                    >
                                                    {{ $t("삭제하기") }}
                                                </b-btn>
                                            </template>
                                        </template>
                                    </b-table>
                                </b-col>
                            </b-row>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import {isValidURL} from '@core/utils/subComponent/check-attachment';
import {waitTime} from '@shared/utils/common';
import jmespath from 'jmespath';

export default {
    name: 'AttachmentsStorage',
    components: {},
    data() {
        return {
            upload_tab_idx: 0,
            attachment_files: [],
            attachment_url: 'https://',
            uploading_file: [],
            uploading_urls: [],
            saving_files: false
        };
    },
    computed: {
        ...mapState(['campaign_in_progress', 'company_id']),
        ...mapState('attachments', ['is_loading_attachments_list', 'is_loading_add_attachment', 'is_loading_link_attachment', 'is_loading_delete_attachment']),
        ...mapGetters('attachments', ['get_attatchments', 'is_loading_global_disabled']),
        ...mapState(['template_in_progress']),
        ...mapState('questions', ['subs']),
        get_question_name(){
            return (sub) => {
                if(this.$i18n.locale === 'ko') {
                    return sub.question_name;
                }
                if(this.$i18n.locale === 'en') {
                    return sub.question_name_e ?? sub.question_name;
                }
                if(this.$i18n.locale === 'ca') {
                    return sub.question_name_c ?? sub.question_name_e ?? sub.question_name;
                }
               
            };
        },
        get_sub_code_label(){
            return (sub) => {
                return sub.label ?? sub.sub_code;      
            };
        },
        upload_fields () {
            return [
                {
                    key: 'index',
                    label: 'No.',
                    thStyle: {
                        'width': '5%'
                    },
                    tdClass: ['text-right']
                },
                {
                    key: 'type',
                    label: this.$t('첨부 파일 유형'),
                    thStyle: {
                        'width': '10%'
                    },
                },
                {
                    key: 'name',
                    label: this.$t('파일 이름'),
                    thStyle: {
                        'width': '85%'
                    },
                },
                {
                    key: 'action',
                    label: ''
                },

            ];
        },
        attachments_field () {
            return [
                {
                    key: 'index',
                    label: 'No.',
                    thStyle: {
                        'width': '5%'
                    },
                    tdClass: ['f-95']
                },
                {
                    key: 'attachment_type',
                    label: this.$t('첨부 파일 유형'),
                    thStyle: {
                        'width': '10%'
                    },
                    tdClass: ['f-90']
                },
                {
                    key: 'filename',
                    label: this.$t('파일 이름'),
                    thStyle: {},
                    tdClass: ['f-90']
                },
                {
                    key: 'sub_list',
                    label: this.$t('첨부 질문 및 문항'),
                    thStyle: {
                        'width': '15%',
                        tdClass: ['f-90', 'text-left']
                    },
                    tdClass: ['f-90', 'text-center']
                },
                {
                    key: 'user',
                    label: this.$t('첨부 파일 제출자'),
                    thStyle: {
                        'width': '10.5%',
                        'text-align': 'center'
                    },
                    tdClass: ['f-90', 'text-center']
                },
                {
                    key: 'action',
                    label: this.$t('설정 및 삭제'),
                    thStyle: {
                        'width': '18%',
                        'text-align': 'center'
                    },
                    tdClass: ['f-90', 'text-center']
                }
            ];
        },
        attachment_uploader_placeholder () {
            return this.$t('첨부할 문서들을 선택해주세요.') + ' ' + this.$t('(복수의 파일 선택 가능)');
        },
        company_id () {
            return this.$route.query.cpn;
        },
        campaign_id () {
            return this.$route.query.cmp;
        },
        uploading_list () {
            const _uploading_list = [];
            if (this.uploading_file.length) {
                this.uploading_file.forEach(file => {
                    _uploading_list.push({ type: 'file', name: file.name, file });
                });
            }

            if (this.uploading_urls.length) {
                this.uploading_urls.forEach(url => {
                    _uploading_list.push({ type: 'url', name: url, url });  
                });
            }

            return _uploading_list;
        },
        another_question_list () {
            let new_list = [];
            this.template_in_progress.template_contents.forEach( x=> {
                x.children.forEach(y => {
                    y.children.forEach(z => new_list.push(z));
                });
            });
            return new_list;
        }
    },
    async created() {
        try {
            this.upload_tab_idx = 0;
            await this.getAttatchments({
                campaign_id: this.$route.query.cmp,
                company_id: this.$route.query.cpn
            });
        } catch (error) {
            if (error.response) {
                console.log(' ~ error.response => ', error.response);
            } else {
                console.log(' ~ error => ', error);
            }
        }
    },
    mounted() {},
    beforeDestroy () {
        this.upload_tab_idx = 0;
        this.attachment_files = [];
        this.attachment_url = 'https://';
        this.uploading_file = [];
        this.uploading_urls = [];
        this.saving_files = false;
    },
    methods: {
        ...mapMutations('attachments', ['initAttachmentsStorage']),
        ...mapActions('attachments', ['getAttatchments', 'unlinkAttachments', 'uploadAttachments', 'deleteAttachments']),
        cancelAttachment () {
            this.attachment_files = [];
            this.attachment_url = 'https://';
            this.uploading_file = [];
            this.uploading_urls = [];
        },
        addFiletoUploadList () {
            const _failed_file_list = [];
            const _uploading_files = [];

            const allowedExtensions = new Set([
                'txt', 'md', 'json', 'xml', 'csv',
                'pdf', 'docx',
                'xls', 'xlsx',
                'pptx',
                'png', 'jpg', 'jpeg', 'gif'
            ]);
            const maxSizeMB = 30;
            const maxFilesCount = 20;

            if (this.attachment_files.length > maxFilesCount) {
                this.$showModal({
                    type: 'alert',
                    state: 'warning',
                    title: this.$t('최대 업로드 파일 개수 초과'),
                    message: this.$t(`한 번에 업로드할 수 있는 파일은 최대 ${maxFilesCount}개 입니다.`)
                });
                
                return;
            }
            this.attachment_files.map(_file => {
                const ext = _file.name.split('.').pop().toLowerCase();
                if(!_file.name.includes('.')) {
                    _failed_file_list.push({
                        name: _file.name,
                        reason: this.$t('파일 확장자가 없습니다.')
                    });
                }
                else if (!allowedExtensions.has(ext)) {
                    _failed_file_list.push({
                        name: _file.name,
                        reason: this.$t('허용하지 않는 파일 형식입니다.')
                    });
                }
                else if(_file.size === 0) {
                    _failed_file_list.push({
                        name: _file.name,
                        reason: this.$t('빈 파일입니다.')
                    });
                }
                else if(_file.size > 1024 * 1024 * maxSizeMB) {
                    _failed_file_list.push({
                        name: _file.name,
                        reason: this.$t('파일 크기가 30MB를 초과합니다.')
                    });
                }
                else if(this.uploading_file.find(({ name, size }) => name === _file.name && size === _file.size)){
                    _failed_file_list.push({
                        name: _file.name,
                        reason: this.$t('이미 업로드 목록에 존재하는 파일입니다.')
                    });
                }
                else {
                    _uploading_files.push(_file);
                }
            });

            if(_failed_file_list.length > 0) {
                const h = this.$createElement;

                this.$showModal({
                    type: 'alert',
                    state: 'warning',
                    title: this.$t('조건에 맞지 않는 파일은 제외되었습니다.'),
                    message: h('div', [
                        h('ul', _failed_file_list.map( file => h('li', `${file.name} : ${file.reason}`)))
                    ])
                });
            }
            this.uploading_file = this.uploading_file.concat(_uploading_files);
            
            this.attachment_files = [];

            if (this.upload_tab_idx !== 1) {
                this.upload_tab_idx = 1;
            }
        },
        deleteFiletoUploadList (_file) {
            if (this.uploading_file.length) {
                const _delete_file_idx = this.uploading_file.findIndex(file => file.name === _file.name && file.size === _file.file.size);
                if (_delete_file_idx > -1) {
                    this.uploading_file.splice(_delete_file_idx, 1);
                }
            }
        },
        addURLtoUploadList () {
            if (!this.attachment_url) {
                return false;
            }

            const _is_included_url = this.uploading_urls.find((url) => url === this.attachment_url);
            if (_is_included_url) {
                alert(this.$t('이미 첨부된 주소 입니다.'));
                return false;
            }

            if (!this.isValidURL(this.attachment_url)) {
                alert(this.$t('올바른 URL 형식으로 입력해 주십시오 (http/https)'));
                return false;
            }

            this.uploading_urls.push(this.attachment_url);

            if (this.upload_tab_idx !== 1) {
                this.upload_tab_idx = 1;
            }
        },
        deleteURLtoUploadList (_url) {
            if (this.uploading_urls.length) {
                const _delete_url_idx = this.uploading_urls.findIndex(url => url === _url);
                if (_delete_url_idx > -1) {
                    this.uploading_urls.splice(_delete_url_idx, 1);
                }
            }
        },
        async uploadAttachment () {
            try {
                this.saving_files = true;

                if (this.uploading_list.length) {
                    if (this.upload_tab_idx !== 1) {
                        this.upload_tab_idx = 1;
                    }
                    await this.uploadAttachments({
                        company_id: this.$route.query.cpn,
                        campaign_id: this.$route.query.cmp,
                        uploadAttchmts: this.uploading_list
                    });    
                }

                this.upload_tab_idx = 0;
                this.uploading_file = [];
                this.uploading_urls = [];
            } catch (error) {
                alert(this.$t('파일 업로드에 실패하였습니다. 다시 시도해 주세요.'));
            } finally {
                this.saving_files = false;
            }
            
        },
        async deleteAttachment (achmt) {
            try {
                await this.deleteAttachments({
                    company_id: this.$route.query.cpn,
                    campaign_id: this.$route.query.cmp,
                    storage_id: [achmt.item.id]
                });   
            } catch (error) {
                alert(this.$t('파일 삭제 중 장애가 발생하였습니다. 다시 시도해 주세요.'));
                await this.getAttatchments();
            }
        },
        async unlinkAllAttachment (attachment) {
            try {
                const { campaign_id, company_id } = attachment;

                const unlinkForms = {};
                for (const { id, sub_path, sub_code } of [ ...attachment.sub_list ]) {
                    if(unlinkForms[id] == null){
                        unlinkForms[id] = {
                            campaign_id,
                            company_id,
                            sub_id: id,
                            sub_code,
                        };
                    }
                    if(sub_path != null){
                        if(unlinkForms[id].inner_storage == null){
                            unlinkForms[id].inner_storage = [];
                        }
                        unlinkForms[id].inner_storage.push({
                            storage_id: attachment.id, sub_path
                        });
                    }
                    else {
                        if(unlinkForms[id].storage_id == null){
                            unlinkForms[id].storage_id = [];
                        }
                        unlinkForms[id].storage_id.push(attachment.id);
                    }
                }
                
                const subCodeList = [];
                const subCodeInnerStorage = {};
                
                for (const unlinkForm of Object.values(unlinkForms)) {
                    if(unlinkForm.inner_storage != null){
                        await this.unlinkAttachments({
                            ...unlinkForm,
                            storage_id: undefined
                        });
                        
                        subCodeList.push(unlinkForm.sub_code);
                        subCodeInnerStorage[unlinkForm.sub_code] = unlinkForm.inner_storage;
                    }
                    else {
                        await this.unlinkAttachments({
                            ...unlinkForm,
                            inner_storage: undefined
                        });
                    }
                }
                if(subCodeList.length > 0){
                    const {data} = await this.$axios.get('/subs', {
                        params: {
                            sub_codes: subCodeList.join(','),
                            company_id: this.$route.query.cpn,
                            campaign_id: this.$route.query.cmp
                        }
                    });
                    
                    const promiseList = [];

                    for (const sub of data) {
                        const temp_sub_data_contents = JSON.parse(JSON.stringify(sub.sub_data_contents));

                        subCodeInnerStorage[sub.sub_code].forEach(storage => {
                            const target = jmespath.search(temp_sub_data_contents, storage.sub_path);
                            target.attachments = target.attachments.filter(id => id !== storage.storage_id);
                        });
                        
                        const targetQuestion = this.another_question_list.find(question => {
                            return question.question_contents.includes(sub.sub_code);
                        });
                        
                        const api = this.$axios.post('/subs', {
                            sub_id: sub.sub_id,
                            sub_init_id: sub.sub_init_id,
                            company_id: sub.company_id,
                            company_name: sub.company_name,
                            campaign_id: sub.campaign_id,
                            sub_code: sub.sub_code,
                            sub_data_contents: temp_sub_data_contents,
                            question_code: targetQuestion.question_code
                        }).then((response)=>{
                            this.$store.commit('questions/update_sub', response.data);
                        });
                        promiseList.push(api);
                    }
                    await Promise.all(promiseList);
                }
            } catch (error) {
                console.dir(error);
                alert(this.$t('죄송합니다. 첨부 해제 중 장애가 발생했습니다. 다시 시도해주세요.'));
                await this.getAttatchments();
            }
        },
        isValidURL(str) {
            return isValidURL(str);
        },
    }
};
</script>
